import React, { useState, useEffect } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import DialogContentText from '@material-ui/core/DialogContentText';
import settings from '../../../settings';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(0)
  },
  loading: {
    display: 'block',
    margin: '8rem auto',
  },
  inputContainer: {
    marginTop: '2rem',
  },
  buttonContainer: {
    marginTop: '2rem',
  },
  connectedText: {
    fontWeight: 'bold',
    color: 'green',
  },
}));

const APP_ID = settings.libraryAppId;

export default function IntegrationsTab(props) {

  const { user } = props;

  const classes = useStyles();

  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [integration, setIntegration] = useState(null);
  const [inputEmail, setInputEmail] = useState("");

  useEffect(() => {
    const fetchIntegration = async () => {
      setProcessing(true);
      const authToken = await user.getIdToken();
      const url = `${process.env.REACT_APP_API_URL}/integrations/${APP_ID}`;
      const response = await fetch(url, {
        method: 'GET',
        headers: new Headers({
         'Authorization': `Bearer ${authToken}`,
         'Accept': 'application/json',
         'Content-Type': 'application/json',
        }),
      })
      if (response.ok) {
        const integration = await response.json();
        console.log(integration)
        setIntegration(integration);
        setInputEmail(integration.app_user_email)
      }
      setProcessing(false);
      setLoading(false);
    }
    fetchIntegration();
  }, []);

  const createIntegration = async () => {
    setProcessing(true);
    const payload = {
      app_user_email: inputEmail,
    }
    const authToken = await user.getIdToken();
    const url = `${process.env.REACT_APP_API_URL}/integrations/${APP_ID}`;
    const response = await fetch(url, {
      method: 'POST',
      headers: new Headers({
        'Authorization': `Bearer ${authToken}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(payload),
    })
    if (response.ok) {
      const data = await response.json()
      setIntegration(data);
    } else {
      const errorText = await response.text();
      alert(errorText);
    }
    setProcessing(false);
  }

  const deleteIntegration = async () => {
    setProcessing(true);
    const authToken = await user.getIdToken();
    const url = `${process.env.REACT_APP_API_URL}/integrations/${APP_ID}/${integration.id}`;
    const response = await fetch(url, {
      method: 'DELETE',
      headers: new Headers({
        'Authorization': `Bearer ${authToken}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }),
    })
    if (response.ok) {
      setIntegration(null);
      setInputEmail("");
    } else {
      const errorText = await response.text();
      alert(errorText);
    }
    setProcessing(false);
  }

  if (loading) {
    return <CircularProgress className={classes.loading} />
  }

  return (
    <React.Fragment>
      {/*
      <DialogContentText classes={{ root: classes.root }}>
        <p>
          If you participate in Early Access for new Chessvision.ai Library App, here's the place where you can set up integration 
          with your eBook Reader account.
        </p>

        <p>
          Integration without joining Early Access has no effect.
        </p>

        <p>
        If you're not part of Early Access you can apply here:
        </p>

        <Button variant="outlined" size="small"
          href={`mailto:${settings.values.supportEmail}?subject=Join Chessvision.ai Library Early Access`}
          rel="noopener noreferrer"
          target="_blank"
        >
          Join Library Early Access
        </Button>

      </DialogContentText>
      */}

      <h4 style={{ marginTop: '4rem' }}>Integration Setup</h4>
      <div className={classes.inputContainer}>
        <TextField
          label="Email address"
          value={inputEmail}
          // helperText="Email address associated with your Early Access (beta)"
          helperText="Email address associated with your Library account"
          onChange={e => setInputEmail(e.target.value.trim())}
          disabled={!!integration}
        />
      </div>
      <div className={classes.buttonContainer}>
        {integration
          ? (
            <div>
              <span className={classes.connectedText}>CONNECTED</span>
              {/* <p>You can now go to the beta app and enjoy your Reader integration!</p> */}
              <p>You can now go to Library app and enjoy your Reader integration!</p>
              <Button
                onClick={deleteIntegration}
                variant="outlined"
                disabled={processing}
              >Disconnect</Button>
            </div>
          )
          : (
            <Button
              onClick={createIntegration}
              variant="contained"
              disabled={processing || !inputEmail.length}
            >Connect</Button>
          )
        }
      </div>
      <DialogContentText classes={{ root: classes.root }} style={{ marginTop: 10 }}>
        <p>
          NOTE: If you participated in Early Access for the Chessvision.ai Library App, you need to setup your integration here again because the app has been offcially moved to production and is available at <a href="https://my.chessvision.ai" target="_blank" rel="noopener noreferrer">my.chessvision.ai</a>. 
        </p>

        <p>If you want to move your content from the Early Access to the official app now, please contact us</p>

      </DialogContentText>
    </React.Fragment>
  );
}


